import React from 'react';
import classnames from 'classnames';
import getSelectedVariantName from '../../utils/getSelectedVariant';
import { MessagePropertiesContext } from '../../../../../contexts/messageProperties';
import PriceLine from '../../../../lister/components/products/product/components/priceLine';
import Availability from '../availability/availability';
import Link from '../link/link';
import Image from '../../../../../components/image';
import { ImageTransformation, ProductDimensionShape } from '../../../../../types';
import styles from './style.module.pcss';

interface ProductStyleProps {
  productData: ProductDimensionShape;
}

const { productCode } = window.globalProductDetails;

function ProductStyle({
  productData: {
    url,
    code,
    image,
    colourSwatch,
    variantOptions,
    variantType,
    price,
    wasPrice,
    wasWasPrice,
    priceUponEnquiry
  }
}: ProductStyleProps): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  const isSelected = code === productCode;
  const selectedVariant = getSelectedVariantName();
  const isAvailable = selectedVariant ? !!variantOptions.find((o) => o.value === selectedVariant) : true;

  return (
    <>
      <div
        className={classnames(styles.style, {
          [styles['style--selected']]: isSelected
        })}
      >
        <div className={styles['style__image-container']}>
          <Image
            src={image}
            alt={colourSwatch?.name}
            transformationTemplates={{
              1: ImageTransformation.LOUPDP_T,
              2: ImageTransformation.LOUPDP_T_R
            }}
          />
        </div>
        <div className={styles['style__details']}>
          <span className={styles['style__name']}>{colourSwatch?.name}</span>
          <PriceLine price={price} wasPrice={wasPrice} wasWasPrice={wasWasPrice} priceUponEnquiry={priceUponEnquiry} />
          {!isSelected && (
            <>
              <Availability isAvailable={isAvailable} variantType={variantType} />
              <Link href={url} />
            </>
          )}
        </div>
        <div className={styles['style__status']}>
          <p>{formattedMessage({ id: 'product.other.styles.selected', fallback: 'Selected Style' })}</p>
        </div>
      </div>
      {isSelected && (
        <div className={styles['style__also']}>
          {formattedMessage({ id: 'product.other.styles.also', fallback: 'Also available in:' })}
        </div>
      )}
    </>
  );
}

export default ProductStyle;
